<script>
  import Figure from '$lib/Figure.svelte'

  export let backdrop = false
  export let white = false
  /** @type {import('@prismicio/types').ImageField<'mobile', 'filled'>} */
  export let image
  /** @type {string?} */
  export let video = null
</script>

<div class="media" class:backdrop class:white>
  {#if image.url || video}
    <div class="figure">
      <Figure {image} {video} fill />
    </div>
  {/if}
  <div class="content">
    <slot />
  </div>
</div>

<style>
  .media {
    --current-background: rgb(var(--rgb-light-gray));

    position: relative;
    display: flex;
    width: 100%;
    border-radius: var(--border-radius-xl);
  }

  .media:not(:has(.figure)) {
    min-height: none;
  }

  .white {
    --current-background: rgb(var(--rgb-blue));
    --current-color: rgb(var(--rgb-white));
    --current-heading-color: rgb(var(--rgb-white));
    --rgb-link: var(--rgb-white);
  }

  .figure {
    position: absolute;
    inset: 0;
    user-select: none;
    overflow: hidden;
    border-radius: var(--border-radius-xl);
  }

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    width: 100%;
    gap: 1rem;
    padding: min(max(var(--document-margin), 4rem), 5rem)
      max(var(--document-margin), 1.5rem)
      min(max(var(--document-margin), 1.5rem), 5rem);
    flex-direction: column;
    align-items: start;
    justify-content: end;
    text-wrap: balance;
    background: var(--current-background);
    border-radius: var(--border-radius-xl);
  }

  .backdrop .content {
    background: rgba(0, 0, 0, 0.5);
    border-radius: var(--border-radius-xl);
  }
</style>
